import { createAcpResource } from 'syft-acp-core/api/resource'

export const resSalesWins = createAcpResource('resSalesWins', {
  uri: [({ salesWinID }) => `/admin/sales/sales_wins/${salesWinID}/pricing_plans`, 'GET', 'POST'],
  uriVars: ['salesWinID'],
})
